import { render, staticRenderFns } from "./mySubscribe.vue?vue&type=template&id=5b445df6&scoped=true"
import script from "./mySubscribe.vue?vue&type=script&lang=js"
export * from "./mySubscribe.vue?vue&type=script&lang=js"
import style0 from "./mySubscribe.vue?vue&type=style&index=0&id=5b445df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b445df6",
  null
  
)

export default component.exports